import { render, staticRenderFns } from "./ApiLookupHeadersFormSection.vue?vue&type=template&id=5628de7e&scoped=true&"
import script from "./ApiLookupHeadersFormSection.vue?vue&type=script&lang=js&"
export * from "./ApiLookupHeadersFormSection.vue?vue&type=script&lang=js&"
import style0 from "./ApiLookupHeadersFormSection.vue?vue&type=style&index=0&id=5628de7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5628de7e",
  null
  
)

export default component.exports